// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as React from "react";
import * as RecordsWrapper from "./RecordsWrapper.bs.js";
import * as Accordion$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/Accordion.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";

function getViewLabel(load_assist_info) {
  var count = load_assist_info.no_of_partners;
  var partnerCountDisplay = count !== 1 ? (
      count !== 2 ? String(count) : "Helper + Labour"
    ) : "Helper";
  var base_fields_0 = {
    label: "Service Type",
    value: {
      TAG: /* Text */0,
      _0: load_assist_info.service_type
    }
  };
  var base_fields_1 = {
    hd: {
      label: "Number of Partners",
      value: {
        TAG: /* Text */0,
        _0: partnerCountDisplay
      }
    },
    tl: {
      hd: {
        label: "Pickup Floor",
        value: {
          TAG: /* Text */0,
          _0: String(load_assist_info.pickup_floor)
        }
      },
      tl: {
        hd: {
          label: "Pickup Lift",
          value: {
            TAG: /* Text */0,
            _0: load_assist_info.pickup_lift ? "Yes" : "No"
          }
        },
        tl: {
          hd: {
            label: "Drop Floor",
            value: {
              TAG: /* Text */0,
              _0: String(load_assist_info.drop_floor)
            }
          },
          tl: {
            hd: {
              label: "Drop Lift",
              value: {
                TAG: /* Text */0,
                _0: load_assist_info.drop_lift ? "Yes" : "No"
              }
            },
            tl: /* [] */0
          }
        }
      }
    }
  };
  var base_fields = {
    hd: base_fields_0,
    tl: base_fields_1
  };
  var goods_type = load_assist_info.goods_type;
  var goods_type_field = goods_type === "" ? /* [] */0 : ({
        hd: {
          label: "Goods Type",
          value: {
            TAG: /* Text */0,
            _0: goods_type
          }
        },
        tl: /* [] */0
      });
  return List.concat({
              hd: goods_type_field,
              tl: {
                hd: base_fields,
                tl: /* [] */0
              }
            });
}

function NLOrderLoadAssistInfo(Props) {
  var load_assist_info = Props.load_assist_info;
  return React.createElement(Accordion$Catalyst.make, {
              panels: {
                hd: AccordionTypes$Catalyst.make_props({
                      TAG: /* Text */0,
                      _0: "Load Assist Information"
                    }, undefined, undefined, React.createElement(RecordsWrapper.make, {
                          children: CardRowViewMapper$Catalyst.CardRecordView.make("record", getViewLabel(load_assist_info))
                        }), undefined),
                tl: /* [] */0
              },
              className: "c-nlo-accordion-cmp"
            });
}

var make = NLOrderLoadAssistInfo;

export {
  getViewLabel ,
  make ,
  
}
/* react Not a pure module */
